import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Box } from '@hover/blueprint';

const BETTER_WAY_TO_BUILD_CAROUSEL_DATA = [
  {
    img: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={250}
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_text.png"
      />
    ),
    body: 'A contractor sent you a text. Follow the prompt and download the HOVER app.',
    index: 0,
  },
  {
    img: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={250}
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_password.png"
      />
    ),
    body: 'Set up your account and secure it with a password.',
    index: 1,
  },
  {
    img: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={250}
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_snap.png"
      />
    ),
    body: 'Snap photos while walking around your home.',
    index: 2,
  },
  {
    img: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={250}
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_3d.png"
      />
    ),
    body: 'We notify you as soon as your 3D model is ready. (24-48 hours)',
    index: 3,
  },
  {
    img: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        width={250}
        objectFit="contain"
        alt="phone"
        src="../assets/images/invited_by_contractor_mobile_studio.png"
      />
    ),
    body: 'Visualize real products on your actual home in 3D using our Design Studio.',
    index: 4,
  },
  {
    img: (
      <Box mt="22px">
        <StaticImage
          quality={100}
          placeholder="blurred"
          width={250}
          objectFit="contain"
          alt="phone"
          src="../assets/images/invited-contractor.png"
        />
      </Box>
    ),
    body: 'Collaborate with your contractor to estimate costs.',
    index: 5,
  },
];

export default BETTER_WAY_TO_BUILD_CAROUSEL_DATA;
